import { useTranslation } from "react-i18next";

const ServiceOne = ({isGradient}) => {
  const { t } = useTranslation();
  const points = t("solutionsSection.points", { returnObjects: true });
  const icons = [
    "assets/images/icons/solution-icon1.svg",
    "assets/images/icons/solution-icon2.svg",
    "assets/images/icons/solution-icon3.svg",
    "assets/images/icons/solution-icon4.svg",
    "assets/images/icons/solution-icon5.svg",
    "assets/images/icons/solution-icon6.svg",
    "assets/images/icons/solution-icon7.svg",
  ]

  return (
    <section id="solutions" className="service padding-y-120 position-relative z-index-1 overflow-hidden section-bg">
            {isGradient && <img src="assets/images/gradients/solutions-gradient.png" alt="" className="bg--gradient" />}

      <div className="container container-three" style={{paddingInline: 20}}>
        <div className="section-heading style-left style-flex flx-between align-items-end gap-3">
          <div className="section-heading__inner w-lg">
            <h3 className="section-heading__title">
              {t("solutionsSection.title")}
            </h3>
            <p className="section-heading__desc">
              {t("solutionsSection.desc")}
            </p>
          </div>
        </div>
        <div className="row gy-4">
          {points.map((point, index) => (
            <div className="col-lg-4 col-sm-6 col-xs-6" key={index}>
              <div className="service-item hover-bg-main">
                {/* <img
                  src="assets/images/gradients/service-hover-bg.png"
                  alt=""
                  className="hover-bg white-version"
                /> */}
                {/* <img
                  src="assets/images/gradients/service-hover-bg-dark.png"
                  alt=""
                  className="hover-bg dark-version"
                /> */}
                <span >
                  <img src={icons[index]} alt="" />
                </span>
                <h6 className="service-item__title my-3">{point.title}</h6>
                <p className="service-item__desc">{point.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceOne;
